<template>
  <div :class="$style.bind">
    <!-- <img :src="`${$cdnUrl}/offlinePay/banner4.png`" alt="" /> -->
    <img :src="`${$cdnUrl}/offlinePay/button6.png`" alt="" @click="$emit('showBindToast')"/>
  </div>
</template>

<script>
export default {
  name: "",
  data() {
    return {};
  },
};
</script>

<style lang="scss" module>
.bind {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #000000;
  z-index: 10;
  > img:nth-child(1) {
    width: 100%;
  }
  // > img:nth-child(2) {
  //   position: absolute;
  //   left: 50%;
  //   transform: translateX(-50%);
  //   bottom: 40px;
  //   width: 140px;
  //   display: block;
  //   margin: auto;
  //   margin-bottom: 10px;
  // }
}
</style>